import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

/**
 * Reusable digital-signature capture pad.
 * onSign(dataUrl) is called once the user confirms their signature.
 */
export default function ImicoSignaturePad({ label, signerName, signerRole, onSign, saving }) {
  const sigRef = useRef(null);
  const [error, setError] = useState("");

  const handleClear = () => {
    sigRef.current?.clear();
    setError("");
  };

  const handleConfirm = () => {
    if (!sigRef.current || sigRef.current.isEmpty()) {
      setError("Shyiramo umukono mbere yo kwemeza.");
      return;
    }
    const dataUrl = sigRef.current.toDataURL("image/png");
    onSign(dataUrl);
  };

  return (
    <div className="imico-sig-pad-wrap">
      <div className="imico-sig-pad-meta">
        <div className="imico-sig-pad-label">{label}</div>
        <div className="imico-sig-pad-name">{signerName}{signerRole ? ` — ${signerRole}` : ""}</div>
      </div>
      <div className="imico-sig-pad">
        <SignatureCanvas
          ref={sigRef}
          penColor="#1a3a5c"
          canvasProps={{ className: "imico-sig-canvas" }}
        />
      </div>
      {error && <div className="imico-alert imico-alert-warning">{error}</div>}
      <div className="imico-sig-actions">
        <button type="button" className="imico-btn imico-btn-outline imico-btn-sm" onClick={handleClear} disabled={saving}>
          Siba
        </button>
        <button type="button" className="imico-btn imico-btn-primary imico-btn-sm" onClick={handleConfirm} disabled={saving}>
          {saving ? "Kubika..." : "Emeza Umukono"}
        </button>
      </div>
    </div>
  );
}
